import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle", "moreLabel", "lessLabel"]
  static classes = ["collapsed"]

  connect() {
    this.collapse()
    this.#updateToggleVisibility()
  }

  toggle() {
    if (this.contentTarget.classList.contains(this.collapsedClass)) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  expand() {
    this.contentTarget.classList.remove(this.collapsedClass)
    this.moreLabelTarget.classList.add("d-none")
    this.lessLabelTarget.classList.remove("d-none")
  }

  collapse() {
    this.contentTarget.classList.add(this.collapsedClass)
    this.moreLabelTarget.classList.remove("d-none")
    this.lessLabelTarget.classList.add("d-none")
  }

  // A line-clamped box reports the clamped height as its scrollHeight when it
  // holds a single paragraph, so the content is measured with and without the clamp.
  #updateToggleVisibility() {
    const clampedHeight = this.contentTarget.offsetHeight
    this.contentTarget.classList.remove(this.collapsedClass)
    const fullHeight = this.contentTarget.offsetHeight
    this.contentTarget.classList.add(this.collapsedClass)
    this.toggleTarget.classList.toggle("d-none", fullHeight <= clampedHeight)
  }
}
